import { Leaf, Sun } from "lucide-react";

export default function Logo({ size = 30 }) {
  return (
    <div className="relative inline-flex items-center justify-center shrink-0" style={{ width: size + 14, height: size + 14 }}>
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: "var(--gradient-vine)",
          boxShadow: "0 2px 6px rgba(39, 92, 52, 0.25)",
        }}
      />
      <Leaf size={size * 0.62} color="white" strokeWidth={2.6} style={{ position: "relative", zIndex: 1 }} />
      <span
        style={{
          position: "absolute",
          top: -1,
          right: -1,
          width: size * 0.38,
          height: size * 0.38,
          borderRadius: "999px",
          background: "var(--gold)",
          border: "2px solid var(--bg)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Sun size={size * 0.22} color="#7A4B00" strokeWidth={3} />
      </span>
    </div>
  );
}
